module.exports = __webpack_public_path__ + "static/media/hour-glass.1f00696e.png";